<app-close-button *ngIf="type === 'dialog'" (closeButton)="close()"></app-close-button>
<div class="favorite_address" [ngClass]="{popup_style : type === 'popup'}">
  <img class="top_arrow_icon" *ngIf="type === 'popup'" src="assets/images/icons/top_arrow_icon.svg">
  <div class="favorite_address--title">
    {{'address.where_to_deliver' | translate}}
    <div class="favorite_address--title--sub_title">
      {{'address.select_delivery_address' | translate}}
    </div>
  </div>

  <div class="favorite_address--content" [ngClass]="{'popup_h' : type === 'popup'}">
    <div class="favorite_address--content--items pointer flex_between_align_center" *ngFor="let address of favoriteAddress">
      <div class="flex_align_center">
        <label class="radio pointer">
          <input type="radio" class="pointer" name="address"
                 [checked]="address.id === selectedAddressId"
                 [value]="address.id"
                 [(ngModel)]="selectedAddressId"
                 (ngModelChange)="changeSelected(address)"
          >
          <span class="checkmark" [ngClass]="{checked: address.id === selectedAddressId}">
            <img src="assets/images/icons/checkbox_icon.svg">
          </span>
        </label>
        <div class="ml_16 flex_align_center">
          <div class="favorite_address--content--items--address_name">
            {{address.fullAddress}}
          </div>
          <div class="favorite_address--content--items--city_name">
          </div>
        </div>
      </div>
      <img class="edit_button" src="assets/images/icons/edit_favorite_address_icon.svg" (click)="deleteFavoriteAddress(address.id)">
    </div>
  </div>
  <div class="buttons_block">
    <button class="add_address flex_center_align_center pointer" (click)="addNewAddress()">
      <img src="assets/images/icons/plus_Icon.svg">
      <span class="text ml_8">
        {{('address.add_address' | translate) }}
      </span>
    </button>
    <button class="confirm_button pointer" [disabled]="!selectedAddress" (click)="confirm()">
      {{'buttons.confirm' | translate}}
    </button>
  </div>
</div>
